<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'technology-processDictionary',
  components: { PageTable },
}
</script>
